import {getData, postData} from './http';

const url = '/api2/flightsnew/static';
const terminals: Core.AirportTerminalInformation[] = [];

interface ApiAirportTerminal {
    Id: number;
    AirportCode: string;
    Code: string;
    Title: string;
}

export function getTerminalForFlight(airportCode: string, flightCode: string, fromDate: string) {
    const req = {
        CultureCode: TRPCONFIG.Domain.CultureCode,
        AirportCode:airportCode,
        FlightCode:flightCode,
        Date:fromDate
    };

    return postData(`${url}/getterminalforflight`, req, { logErrors: false })
        .then((res: any) => {
            if (res && res.Terminal) {
                return res.Terminal;
            }
            return null;
        });
}


export function getTerminalsForAirport(airportCode: string): Promise<Core.AirportTerminalInformation> {
    const req = { CultureCode: TRPCONFIG.Domain.CultureCode };

    const getTerminal = (airportCode: string): Core.AirportTerminalInformation => {
        return _.find<Core.AirportTerminalInformation>(terminals, t => t.AirportCode === airportCode);
    };

    if (terminals.length === 0) {
        //get and set the terminals
        return postData(`${url}/getterminals`, req, { logErrors: false })
            .then((res: any) => {
                if (res && res.Terminals) {

                    _.forEach(res.Terminals, (v: ApiAirportTerminal) => {
                        let t = getTerminal(v.AirportCode);
                        if (!t) {
                            t = { AirportCode: v.AirportCode, Terminals:[] };
                            terminals.push(t);
                        }

                        t.Terminals.push({Code: v.Code, Title: v.Title});
                    });
                }
                return getTerminal(airportCode);
            });
    } else {
        return Promise.resolve(getTerminal(airportCode));
    }
}

